var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBullputSpread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 34H58",
    stroke: "#E6E6E6",
    strokeLinecap: "round",
    strokeDasharray: "4 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 28.5H61.5V24H42L26 40H32.5L44 28.5Z",
    fill: "#12B16E",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4999 45.5L31.9999 34H38.9999L27.4999 45.5L23 50H7V45.5H20.4999Z",
    fill: "#E94C69"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 34V33.5H31.7928L31.6464 33.6464L31.9999 34ZM20.4999 45.5V46H20.707L20.8535 45.8536L20.4999 45.5ZM38.9999 34L39.3535 34.3536L40.207 33.5H38.9999V34ZM27.4999 45.5L27.1464 45.1464L26.2928 46H27.4999V45.5ZM27.4999 45.5L27.8535 45.8536L28.7071 45H27.5L27.4999 45.5ZM23 50V50.5H23.2071L23.3535 50.3536L23 50ZM7 50H6.5V50.5H7V50ZM7 45.5V45H6.5V45.5H7ZM31.6464 33.6464L20.1464 45.1464L20.8535 45.8536L32.3535 34.3536L31.6464 33.6464ZM38.9999 33.5H31.9999V34.5H38.9999V33.5ZM27.8535 45.8536L39.3535 34.3536L38.6464 33.6464L27.1464 45.1464L27.8535 45.8536ZM23.3535 50.3536L27.8535 45.8536L27.1464 45.1464L22.6464 49.6464L23.3535 50.3536ZM7 50.5H23V49.5H7V50.5ZM6.5 45.5V50H7.5V45.5H6.5ZM20.4999 45H7V46H20.4999V45Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.5V53.5",
    stroke: "#E6E6E6",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullputSpread);
export default __webpack_public_path__ + "static/media/Bull put Spread.9780e81abf738fe0e88414023e87a962.svg";
export { ForwardRef as ReactComponent };